import React from "react";
import { useHelpItems } from "./hooks/useHelpItems";
import HelpHeader from "./components/HelpHeader";
import HelpItemsGrid from "./components/HelpItemsGrid";
import ContactSupport from "./components/ContactSupport";
import styles from "./Help.module.scss";

const Help: React.FC = () => {
  const { helpItems, loading, isAuthenticated, hasUserData } = useHelpItems();

  return (
    <div className={styles.helpPage}>
      <HelpHeader />
      
      <div className={styles.helpContent}>
        <HelpItemsGrid 
          helpItems={helpItems}
          loading={loading}
          isAuthenticated={isAuthenticated}
          hasUserData={hasUserData}
        />
        
        <ContactSupport />
      </div>
    </div>
  );
};

export default Help; 